export default "__VITE_PUBLIC_ASSET__649993a8__"